// src/components/GuestCard.jsx
import React from "react";
import "../styles/PartnerAnalyticsDemo.css";

const formatMMSS = (seconds) => {
  if (seconds === null || seconds === undefined) return null;
  const s = Math.max(0, Number(seconds) || 0);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
};

// ✅ NEW: Default avatar SVG (no image file required)
const DEFAULT_AVATAR_SVG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#2563eb"/>
          <stop offset="100%" stop-color="#ff7b54"/>
        </linearGradient>
      </defs>
      <circle cx="40" cy="40" r="40" fill="url(#g)"/>
      <circle cx="40" cy="32" r="14" fill="rgba(255,255,255,0.85)"/>
      <path d="M18 70c5-14 17-22 22-22s17 8 22 22" fill="rgba(255,255,255,0.85)"/>
    </svg>
  `);

const GuestCard = ({
  guest,
  onAccept,
  showAcceptButton = false,

  // NEW (minimal + optional)
  order = null,
  countdownSeconds = null,
  countdownLabel = null,
  isNextDuringGrace = false,
  graceRemainingSeconds = null,
  graceRemainingLabel = null,
}) => {
  const isActive =
    !showAcceptButton && (guest?.status === "active" || guest?.isActive);

  const activeCountdown =
    countdownLabel ||
    (countdownSeconds !== null ? formatMMSS(countdownSeconds) : null);

  const graceCountdown =
    graceRemainingLabel ||
    (graceRemainingSeconds !== null ? formatMMSS(graceRemainingSeconds) : null);

  // ✅ NEW: avatar fallback
  const avatarSrc = guest?.avatar || DEFAULT_AVATAR_SVG;

  return (
    <div
      className={`guest-item ${isActive ? "guest-item--active" : ""} ${
        isNextDuringGrace ? "guest-item--grace" : ""
      }`}
    >
      {/* ORDER BADGE */}
      {order ? <div className="guest-order-badge">#{order}</div> : null}

      <img
        src={avatarSrc}
        alt={guest?.name || "Guest"}
        className="guest-avatar"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = DEFAULT_AVATAR_SVG;
        }}
      />

      <div className="guest-info">
        <div className="guest-info-top">
          <p className="guest-name">{guest?.name || "Guest"}</p>

          {/* ACTIVE COUNTDOWN shown directly on the card */}
          {isActive && activeCountdown ? (
            <span className="guest-countdown-pill" title="Time remaining">
              {activeCountdown}
            </span>
          ) : null}
        </div>

        <p className="guest-status">
          {showAcceptButton
            ? "Waiting for approval"
            : isNextDuringGrace
            ? `Starting after cleaning…${
                graceCountdown ? ` (${graceCountdown})` : ""
              }`
            : isActive
            ? "Active"
            : "Queued"}
        </p>
      </div>

      {showAcceptButton && (
        <button className="accept-btn" onClick={() => onAccept(guest.id)}>
          Accept
        </button>
      )}
    </div>
  );
};

export default GuestCard;1